import Flex from 'typescript-styled-flex'
import styled from '../../../theme'

const Wrapper = styled(Flex as any)`
  border-radius: 3px;
  border: solid 1px #c4c5c7;
  flex-direction: column;
`

export const LockWrapper = styled.div<{disabled: boolean}>`
    position: relative;
    width: 100%;
    img {
        position: absolute;
        top: 50%;
        left: 50%;
        height: auto;
        width: 24px;
        transform: translate(-50%, -50%);
        pointer-events: none;
    }
    &::after {
        content: '';
        display: ${({ disabled }) => (disabled ? 'block' : 'none')};
        position: absolute;
        inset: 0;
        background: rgba(215, 215, 215, 0.6);
        pointer-events: all;
        cursor: not-allowed;
    }
`

export default Wrapper
